import React from "react"

import { useAppDispatch } from "redux/hooks"
import { makeSignConsent } from "redux/features/consent/consentSignThunk"
import MobileId from "components/Sign/MobileId"
import { MOBILE_ID_SIGN_METHOD } from "config"
import { ClientMobileIdFormValues } from "types"

type Props = {
  onFailure: () => void
  onSuccess: () => void
}

const MobileIdSignComponent = ({ onFailure, onSuccess }: Props) => {
  const dispatch = useAppDispatch()

  const handleSubmit = (values: ClientMobileIdFormValues) => {
    const { personal_code, phone } = values

    const params = {
      signing_method: MOBILE_ID_SIGN_METHOD,
      personal_code,
      phone_number: phone,
    }

    dispatch(makeSignConsent(params))
      .then(() => {
        onSuccess()
      })
      .catch(() => {
        onFailure()
      })
  }

  return <MobileId onSubmit={handleSubmit} />
}

export default MobileIdSignComponent
